import {
  SystemOfMeasuresEnum,
  UserMeasurementHeightUnitType,
} from '@front-activerse/common-components';
import { biometricSettings } from '../types';

const createFormikInitialValues = (biometricSettingsData: any) => {
  const me = biometricSettingsData.me;

  const biometricSettings: biometricSettings = {
    sex: me.sex,
    dateOfBirth: me.birthDate,
    heightValue: Math.round(me.height?.value) || undefined,
    heightUnit:
      me.systemOfMeasures === SystemOfMeasuresEnum.imperial
        ? UserMeasurementHeightUnitType.in
        : UserMeasurementHeightUnitType.cm,
    heightFt: undefined,
    heightIn: undefined,
  };

  return biometricSettings;
};

export default createFormikInitialValues;
